module.exports = __webpack_public_path__ + "img/QUiMICA.faae6567.png";